import React from 'react';
import styled from 'styled-components';
import { SectionParent, BlueButton, H1 } from '../../StyledComponents';
import FirstNameIcon from '../../../assets/formComponents/FirstNameIcon.svg';
import EmailIcon from '../../../assets/formComponents/emailIcon.svg';
// import PhoneIcon from '../../../assets/formComponents/phone.svg';
import {
  StyledInputs,
  PasswordMatchError,
} from '../../HomePage/EsperSignUpFormComponent';
import Axios from 'axios';
import { navigate } from 'gatsby';
import { RequestDemoFormContainer } from '../BookDemo/RequestDemoForm';
import apiHost from '../../../apiHost';

export const StyledTextArea = styled.textarea`
  :focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
    color: black;
    background-image: none;
  }
  box-shadow: ${(props: { error: boolean }) =>
    props.error ? '0 0 0 0.1rem #fd7e7e5e' : 'none'};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 520px) {
    font-size: 12px;
    width: 100%;
  }
  line-height: 1.43;
  ::placeholder {
    color: rgba(107, 124, 147, 0.6);
    opacity: 1; /* Firefox */
  }
  padding: 1.07em 0.5em;
  margin-top: 10px;
  height: 100px;
  min-width: 18rem;
  width: 98%;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 230px;
  }
  /* min-width: 15rem; */
  border: solid 2px #cacaca;
  border-color: ${(props: { error: boolean }) =>
    props.error ? '#eb6161' : 'rgba(107, 124, 147, 0.43)'};
  padding: 0.475rem 0.75rem 0.475rem 1.5rem;
  border-radius: 4px;
  background-position-y: center;
  background-position-x: 0.5rem;
  background-repeat: no-repeat;
  text-indent: 20px;
`;

const RequestDemoFormComponent = styled.div`
  max-width: 90%;
  width: 450px;
  justify-self: left;
  @media (max-width: 780px) {
    justify-self: center;
    width: 350px;
  }
  @media (max-width: 330px) {
    max-width: 18rem;
  }
  @media (min-width: 770px) {
    margin-right: -5%;
  }
`;
// const RequestDemoFormContainer = styled.div`
//   border-radius: 4px;
//   width: 100%;
//   box-shadow: 0 2px 21px 0 rgba(41, 35, 58, 0.12);
//   background-color: #ffffff;
//   display: grid;
//   /* justify-items: center; */
//   padding-top: 2rem;
//   padding-bottom: 2rem;
// `;

const BlueButtonNew = styled(BlueButton)`
  width: 95%;
  min-width: 18rem;
  margin-top: 24px;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  }
`;

const PhoneInput = styled.div`
  grid-column: span 1;
  margin-top: -6px;
  width: 100%;
  /* margin-left: 15px; */
  @media (max-width: 768px) {
    margin-left: 15px;
    width: unset;
  }
`;

export default class RequestDemoForm extends React.Component<any, any> {
  state = {
    name: '',
    email: '',
    referralName: '',
    referralEmail: '',
    notes: '',
    nameError: false,
    emailError: false,
    referralNameError: false,
    referralEmailError: false,
    notesError: false,
    submitError: false,
  };

  isAllValid = () =>
    !(
      this.state.nameError ||
      this.state.emailError ||
      this.state.referralNameError ||
      this.state.referralEmailError
    );

  validateAll = () => {
    this.validateFullName();
    this.validateEmail();
  };
  navigateThankyou = () => {
    localStorage.setItem('prevPage', 'contact-us');
    navigate('/submitted');
  };

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  sendData = () => {
    this.validateAll();
    if (this.isAllValid()) {
      const hubspotToken = this.getCookieValue('hubspotutk');
      Axios({
        url:
          'https://api.hsforms.com/submissions/v3/integration/submit/5868902/3db60d81-a0e5-46d1-b2f8-0f2dad777749',
        method: 'POST',
        data: {
          fields: [
            {
              name: 'email',
              value: this.state.email,
            },
            {
              name: 'firstname',
              value: this.state.name,
            },
            {
              name: 'referral_name',
              value: this.state.referralName,
            },
            {
              name: 'referral_email',
              value: this.state.referralEmail,
            },
            {
              name: 'notes',
              value: this.state.notes,
            },
          ],
          context: {
            hutk: hubspotToken,
            pageUri: window.location.href,
            pageName: document.title,
          },
        },
      })
        .then((response: any) => {
          this.setState({
            contactError: false,
            nameError: false,
            emailError: false,
            email: '',
            name: '',
            contactNumber: '',
          });
          this.navigateThankyou();
        })
        .catch((error: any) => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            error.response.data.errors.forEach((item: any) => {
              if (item.message.includes('fields.email')) {
                this.setState({ emailError: true });
              } else if (item.message.includes('fields.phone')) {
                this.setState({ contactError: true });
              } else {
                console.log('error');
              }
            });
          }
        });
    } else {
      Axios({
        url: `${apiHost.host}collectemail`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Contact Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };

  // VALIDATIONS

  validateFullName = () => {
    if (this.state.name.length === 0 || this.state.name.length > 30) {
      this.setState({
        nameError: true,
      });
    } else {
      this.setState({
        nameError: false,
      });
    }
  };

  validateEmail = (isNotOnFocus?: boolean) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      Axios({
        url: `${apiHost.host}collectemail`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Contact Form`,
          failure: false,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      if (isNotOnFocus) {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      } else {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      }
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  validateReferralEmail = (isNotOnFocus?: boolean) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.referralEmail);
    if (result === true && this.state.referralEmail.length < 150) {
      if (isNotOnFocus) {
        this.setState({
          referralEmailError: false,
          submitError: false,
          referralEmailErrorText: '',
        });
      } else {
        this.setState({
          referralEmailError: false,
          submitError: false,
          referralEmailErrorText: '',
        });
      }
    } else {
      this.setState({
        referralEmailError: true,
      });
    }
  };

  //   Input Recievers

  handleNameChange = (event: any) =>
    this.setState({ name: event.target.value });
  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });
  handleReferralNameChange = (event: any) =>
    this.setState({ referralName: event.target.value });
  handleReferralEmailChange = (event: any) =>
    this.setState({ referralEmail: event.target.value });

  handleNotesChange = (event: any) =>
    this.setState({ notes: event.target.value });
  render() {
    return (
      <RequestDemoFormComponent>
        <RequestDemoFormContainer>
          <H1 style={{ textAlign: 'left', marginBottom: '2rem' }}>
            Refer a friend
          </H1>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="name"
              value={this.state.name}
              backgroundImage={FirstNameIcon}
              aria-label="Full Name"
              maxLength={149}
              onChange={this.handleNameChange}
              onBlur={this.validateFullName}
              error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={'Full Name'}
              name="Full Name"
            />
            <PasswordMatchError id="name-error">
              {this.state.nameError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid name
                </>
              ) : (
                this.state.nameError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.name.length > 1
                      ? 'Please enter a valid name'
                      : 'Please enter your name'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="email"
              value={this.state.email}
              backgroundImage={EmailIcon}
              aria-label="Email"
              maxLength={149}
              onChange={this.handleEmailChange}
              onBlur={this.validateEmail}
              error={this.state.emailError || this.state.submitError}
              type="email"
              placeholder={'Work Email'}
              name="Work Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.emailError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid email address
                </>
              ) : (
                this.state.emailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? 'Please enter a valid email address'
                      : 'Please enter an email address'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="name"
              value={this.state.referralName}
              backgroundImage={FirstNameIcon}
              aria-label="Referral Name"
              maxLength={149}
              onChange={this.handleReferralNameChange}
              onBlur={this.validateFullName}
              error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={'Referral Name'}
              name="Referral Name"
            />
            <PasswordMatchError id="name-error">
              {this.state.nameError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid name
                </>
              ) : (
                this.state.referralNameError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.referralName.length > 1
                      ? 'Please enter a valid name'
                      : 'Please enter your name'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="email"
              value={this.state.referralEmail}
              backgroundImage={EmailIcon}
              aria-label="Email"
              maxLength={149}
              onChange={this.handleReferralEmailChange}
              onBlur={this.validateReferralEmail}
              error={this.state.referralEmailError || this.state.submitError}
              type="email"
              placeholder={'Enter Referral Email'}
              name="Enter Referral Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.referralEmailError === false &&
              this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid email address
                </>
              ) : (
                this.state.referralEmailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.referralEmail.length > 1
                      ? 'Please enter a valid email address'
                      : 'Please enter an email address'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div
            style={{
              display: 'grid',
            }}
          >
            <StyledTextArea
              id="notes"
              aria-label="notes"
              error={this.state.notesError}
              value={this.state.notes}
              //   maxLength={15}
              minLength={14}
              maxLength={200}
              onChange={this.handleNotesChange}
              placeholder={`Notes (Optional)`}
              name="notes"
            />
            <PasswordMatchError id="description-error">
              {this.state.notesError === true && (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter your Message
                </>
              )}
            </PasswordMatchError>
          </div>

          <div style={{ display: 'grid' }}>
            <BlueButtonNew id="request_demo__send" onClick={this.sendData}>
              Send
            </BlueButtonNew>
          </div>
        </RequestDemoFormContainer>
      </RequestDemoFormComponent>
    );
  }
}
